import { EncryptionTypes } from "../constants/encryptionTypes";
import { TranslationKeys } from "../contexts/TranslationKeys";
import { getArrayBufferFromBlob } from "../exporters/LicenseHelper";
import { ToastFunction } from "../models/ReactToastifyType";
import { importCertificate } from "../services/securityPolicyService";
import { getErrorMessage } from "../services/utilities/ServiceError";
import { convertTextPwdToBase64Pwd } from "./Validation";

const normaliseList = (value: string, prefix: string) => {
    return value?.split(',').map((item) => item.trim()).filter((item) => item !== '').map((item) => item.startsWith(prefix) ? item : `${prefix}${item}`) || [];
};

export const buildCertForGeneration = (values, id, siteId, userId) => {
    const dnsList = normaliseList(values.domainNameSystem, 'dns:');
    const ipList = normaliseList(values.internetProtocol, 'ip:');
    const uriList = normaliseList(values.uniformResourceIdentifier, 'uri:');
    const subjectAlternativeName = [...dnsList, ...ipList, ...uriList].join(',');

    let keySize;
    let curve;

    if (values.encryptionType === EncryptionTypes.RSA) {
        keySize = parseInt(values.keyParameter);
    } else if (values.encryptionType === EncryptionTypes.EC) {
        curve = values.keyParameter;
    }

    return {
        id,
        alias: values.alias,
        validityIn: values.validityIn,
        validFor: values.validFor,
        commonName: values.commonName,
        subjectAlternativeName,
        encryptionType: values.encryptionType,
        keySize,
        curve,
        shaAlgorithm: values.shaAlgorithm,
        certificateAuthority: values.isCA || false,
        caCertificateId: values.certificateAuthorityId || null,
        certificateTypeId: values.certificateTypeId || 1, // default to webserver certificate
        siteId,
        userId: userId
    };
};

export const handleImportCertificateSubmit = async (values, setBusy, setModalType, success: ToastFunction, dialog, translate, siteId) => {
    setBusy(true);
    try {
        const passwordBase64Pwd = convertTextPwdToBase64Pwd(values.certificatePassword);
        const arrayBuffer = await getArrayBufferFromBlob(values.certificate);
        const fileSettingType = values.fileSettingsType;
        const fileAsByteArray = Object.values(arrayBuffer);
        if (passwordBase64Pwd) {
            await importCertificate(fileAsByteArray, passwordBase64Pwd, siteId, fileSettingType, translate);
        }
        setModalType(null);
        success(translate.byKey(TranslationKeys.certificateImported));
    } catch (error) {
        dialog.pushError({ title: translate.byKey(TranslationKeys.certificateImportError), message: getErrorMessage(error) });
    }
    setBusy(false);
};
